import { FlashList } from '@shopify/flash-list';
import * as React from 'react';
import { ScrollView, useWindowDimensions } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Small } from '../ui/typography';
import { PaymentData } from './types';

const MIN_COLUMN_WIDTHS = [110, 10, 10, 10, 10, 5];

interface PaymentTableProps {
  paymentData: PaymentData;
}
export default function PaymentTable({ paymentData }: PaymentTableProps) {
  const { width } = useWindowDimensions();
  const insets = useSafeAreaInsets();

  const columnWidths = React.useMemo(() => {
    return MIN_COLUMN_WIDTHS.map((minWidth) => {
      const evenWidth = width / MIN_COLUMN_WIDTHS.length;
      return evenWidth > minWidth ? evenWidth : minWidth;
    });
  }, [width]);

  return (
    <ScrollView
      horizontal
      bounces={false}
      showsHorizontalScrollIndicator={false}
      scrollEventThrottle={16}
      style={{ flex: 1 }}
      contentContainerStyle={{ flexGrow: 1 }}
      nestedScrollEnabled={true}
    >
      <Table aria-labelledby='invoice-table'>
        <TableHeader>
          <TableRow>
            <TableHead className='px-0.5' style={{ width: columnWidths[0] }}>
              <Small>Date</Small>
            </TableHead>
            <TableHead style={{ width: columnWidths[1] }}>
              <Small>Type</Small>
            </TableHead>
            <TableHead style={{ width: columnWidths[2] }}>
              <Small> Period</Small>
            </TableHead>
            <TableHead style={{ width: columnWidths[3] }}>
              <Small>Amount</Small>
            </TableHead>
            <TableHead style={{ width: columnWidths[4] }}>
              <Small>Status</Small>
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {!paymentData.length && (
            <TableRow>
              <TableCell>
                <Small className='text-gray-500'>No Payments in this period</Small>
              </TableCell>
            </TableRow>
          )}
          <FlashList
            data={paymentData}
            scrollEnabled={false}
            contentContainerStyle={{
              paddingBottom: insets.bottom,
            }}
            showsVerticalScrollIndicator={false}
            renderItem={({ item: payment, index }) => {
              return (
                <TableRow
                  key={index}
                >
                  <TableCell style={{ width: columnWidths[0] }}>
                    <Small>{payment.date}</Small>
                  </TableCell>
                  <TableCell style={{ width: columnWidths[1] }}>
                    <Small>
                      {payment.description}
                    </Small>
                  </TableCell>
                  <TableCell style={{ width: columnWidths[2] }}>
                    <Small>{payment.paymentFrom} - {payment.paymentTo}</Small>
                  </TableCell>
                  <TableCell style={{ width: columnWidths[3] }}>
                    <Small>{payment.amount.toFixed(2)}</Small>
                  </TableCell>
                  <TableCell style={{ width: columnWidths[4] }}>
                    <Small>{payment.status}</Small>
                  </TableCell>
                </TableRow>
              );
            }}
          />
        </TableBody>
      </Table>
    </ScrollView>
  );
}